/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';

export class WebhooksService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns void
   * @throws ApiError
   */
  public webhooksControllerFronteggWebhooks(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/webhooks/frontegg',
    });
  }
  /**
   * @param secret
   * @returns any
   * @throws ApiError
   */
  public webhooksControllerTwilioSmsWebhook(
    secret?: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/webhooks/twilio/sms',
      query: {
        secret: secret,
      },
    });
  }
  /**
   * @param splat
   * @returns any
   * @throws ApiError
   */
  public webhooksControllerReceive(splat: string): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/webhooks/{splat}',
      path: {
        splat: splat,
      },
    });
  }
}
